class AccountsService {
  static setAccount = (account) => {
    localStorage.setItem('account', JSON.stringify(account));
  }

  static getAccount = () => {
    const account = localStorage.getItem('account');
    if (account) {
      return JSON.parse(account);
    }

    return null;
  }

  static clearAccount = () => {
    localStorage.removeItem('account');
  }
}

export default AccountsService;


// WEBPACK FOOTER //
// ./src/utils/AccountsService.js